import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2)
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1)
    }
}));

export default function CustomDialog({
    open,
    title,
    onClose,
    children,
    actions,
    maxWidth = "md"
}) {
    return (
        <BootstrapDialog
            onClose={onClose}
            open={open}
            fullWidth
            maxWidth={maxWidth}
            PaperProps={{
                sx: {
                    borderRadius: "15px",
                    border: "1px solid #e2e8f0",
                    width: "100%",
                    maxWidth: { xs: "90%", sm: "600px", md: "800px" },
                    minWidth: { xs: "auto", md: "600px" }
                }
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2 }}>{title}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500]
                })}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent dividers>{children}</DialogContent>

            {actions &&
                <DialogActions
                    sx={{
                        paddingTop: "14px !important",
                        paddingBottom: "14px !important",
                    }}
                >
                    {actions}
                </DialogActions>}
        </BootstrapDialog >
    );
}